export default __webpack_public_path__ + "dd459122eac63993622870ba40832a21.svg";